export default {
    validateMobile(mobile) {
        if (!mobile || mobile.length != 11) {
            return false;
        }
        var myreg = /^((1[3-9]{1})+\d{9})$/;
        if (!myreg.test(mobile)) {
            return false;
        }
        return true;
    },
    validateAuthCode(code) {
        if (code.length != 4) {
            return false;
        }
        return true;
    },
    validateName(name) {
        var regName = /^[\u4e00-\u9fa5]{2,15}$/;
        if (!regName.test(name)) {
            return false;
        }
        return true;
    },
    getQueryString(name) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
        var r = window.location.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]); return null;
    },
    isMobile() {
        var userAgentInfo = navigator.userAgent;
        var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
        var flag = false;
        for (var v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) >= 0) {
                flag = true;
                break;
            }
        }
        return flag;
    }
};


// WEBPACK FOOTER //
// ./src/utils/util.js